import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { loadLanguage } from './components/Language/LoadLanguage.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));

try {
  //英文环境放开，设置en=0,中文en=1
  localStorage.setItem('en','1');
  
  // if(localStorage.getItem('en') === '0'){
  //   console.log('当前语言: en');
  // }else{
  //   console.log('当前语言: zh');
  // }
  let newLang = '';
  if (localStorage.getItem('en') === '0') {
    newLang = await loadLanguage('en');
  }else{
    newLang = await loadLanguage('zh');
  }
  localStorage.setItem('Lang', JSON.stringify(newLang));
} catch (error) {
  console.error('Error loading locale:', error);
}
root.render(
  <BrowserRouter>
      <App />
  </BrowserRouter>
);


// ReactDOM.render(
//   <AppContext.Provider value={someValue}>
//     <App />
//   </AppContext.Provider>,
//   document.getElementById('root')
// );

// ReactDOM.render(
//   <AppContext.Provider value={someValue}>
//     <App />
//   </AppContext.Provider>,
//   document.getElementById('root')
// );

// root.render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>,
// <GlobalContext.Provider value={someValue}>
//     <App />
//   </GlobalContext.Provider>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
